import {SuspenseWhileLoading} from '@oc/components'
import React from 'react'

const Customer = React.lazy(async () => ({
    default: (await import('@oc/customer/module')).CustomerModule
}))

export function CustomerComponent() {
    return <SuspenseWhileLoading LazyComponent={Customer} />
}

const Dashboard = React.lazy(async () => ({
    default: (await import('@oc/customer/module')).DashboardModule
}))

export function DashboardComponent() {
    return <SuspenseWhileLoading LazyComponent={Dashboard} />
}
